module.exports = "/_next/static/images/thinking_face-949f6e768dd633c78b07ae0878d5e95c.png";